// Публичные эндпоинты авторизации: 401 от них означает неверные данные,
// а не протухший access token, поэтому refresh для них не запускаем.
const AUTH_ENDPOINT_RE = /\/auth\/(login|register|refresh|forgot-password|reset-password|verify-phone|resend-verification)(\/|\?|$)/;

export const isAuthEndpoint = (url) => AUTH_ENDPOINT_RE.test(String(url || ''));

// Пытаться ли обновить токен после ответа с ошибкой.
// Наличие refresh-токена не проверяем: без него refreshAccessToken падает и
// сессия очищается с редиректом на /login — как было до правки.
export const shouldAttemptRefresh = ({ status, url, retried }) =>
  status === 401 && !retried && !isAuthEndpoint(url);
